const Indicator = ({ show }) => {
  if (!show) return null;
  return (
    <span
      className="
      absolute flex h-2 w-2 
      top-[-3px] left-[-3px]
    "
    >
      <span
        className="
        animate-ping absolute inline-flex 
        h-full w-full rounded-full bg-[#45d4d5]
        opacity-75
      "
      />
      <span
        className="
        relative inline-flex rounded-full 
        h-2 w-2 bg-[#45d4d5]
      "
      />
    </span>
  );
};

export default Indicator;
